export const enum WalletConnectionError {
  Canceled = 'WALLET_CONNECTION_CANCELED',
  WrongAccount = 'WALLET_CONNECTION_WRONG_ACCOUNT',
}
